import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Component({
  selector: 'app-ag-file-upload',
  templateUrl: './ag-file-upload.component.html',
  styleUrls: ['./ag-file-upload.component.css']
})
export class AgFileUploadComponent implements OnInit {

  @Input() TasacionID: number;
  @Input() TipoArchivo: string;

  @Input() EstanciaId: string;
  @Input() Version: string;
  @Input() isFromEntityType: boolean = false;
  @Input() entityType: any;
  @Input() entityId: any;


  @Output() FileUploaded: EventEmitter<any> = new EventEmitter();

  private myAppUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    this.myAppUrl = this.baseUrl;
  }

  public files: UploadFile[] = [];

  ngOnInit() {
  }

  public dropped(event: UploadEvent) {
    this.files = event.files;
    for (const droppedFile of event.files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.sendFile(file);
        });
      }
    }
  }

  public sendFile(file) {

    const formData = new FormData();
    // Headers
    const headers = new HttpHeaders({
      'security-token': 'mytoken'
    });

    if (this.isFromEntityType) {
      formData.append('entityId', this.entityId.toString());
      formData.append('entityType', this.entityType);
      formData.append('files', file, file.name);

      this.http.post(this.myAppUrl + 'api/File', formData, {
        headers: headers,
        responseType: 'blob',
      }).subscribe(data => {
        this.FileUploaded.emit();
      });

    } else {
      formData.append('TasaID', this.TasacionID.toString());
      formData.append('TipoArchivo', this.TipoArchivo);
      formData.append('EstanciaId', this.EstanciaId);
      formData.append('Version', this.Version);

      // Here you can access the real file
      // console.log(droppedFile.relativePath, file);

      // You could upload it like this:
      formData.append('tasaFile', file, file.name);

      this.http.post(this.myAppUrl + 'api/tasaciones/fileUpload', formData, { headers: headers, responseType: 'blob' })
        .subscribe(data => {
          // Sanitized logo returned from backend
          this.FileUploaded.emit();
        });
    }
  }

  onFileChanged(event) {
    const selectedFile = event.target.files[0];
    this.sendFile(selectedFile);
  }


  /*
      public fileOver(event) {
        console.log(event);
      }

      public fileLeave(event) {
        console.log(event);
      }
  */
}
